// Localização permanece no dispositivo até existir consentimento e partilha segura.
const position=()=>new Promise((resolve,reject)=>navigator.geolocation?.getCurrentPosition(p=>resolve({lat:p.coords.latitude,lng:p.coords.longitude,accuracy:p.coords.accuracy,timestamp:p.timestamp}),reject,{enableHighAccuracy:true,timeout:10000})||reject(Error('Geolocalização não suportada')))
export const locationService={
 updateMyLocation:async()=>({success:false,error:'Partilha de localização ainda indisponível'}),
 getMemberLocation:async()=>({success:false,error:'Partilha de localização ainda indisponível'}),
 subscribeToFamilyLocations:callback=>{callback({success:false,error:'Partilha ainda indisponível'});return()=>{}},
 markAsOffline:async()=>({success:true}),
 removeLocation:async()=>({success:false,error:'Indisponível'}),
 getCurrentPosition:position,
 reverseGeocode:async()=>({success:false,error:'Geocodificação indisponível'}),
 calculateDistance:(a,b,c,d)=>{const rad=x=>x*Math.PI/180;const h=Math.sin(rad(c-a)/2)**2+Math.cos(rad(a))*Math.cos(rad(c))*Math.sin(rad(d-b)/2)**2;return 6371*2*Math.atan2(Math.sqrt(h),Math.sqrt(1-h))},
 formatDistance:km=>km<1?Math.round(km*1000)+'m':km.toFixed(1)+'km',
 formatLastUpdate:stamp=>stamp?new Date(stamp).toLocaleString('pt-PT'):'Nunca'
}
export default locationService
